module.exports = __webpack_public_path__ + "img/ufish.de54b0d3.png";